var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticStyle: {
      "max-width": "1185px"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    directives: [{
      name: "touch",
      rawName: "v-touch",
      value: {
        right: function () {
          return _vm.step(-1);
        },
        left: function () {
          return _vm.step(1);
        }
      },
      expression: "{ right: () => step(-1), left: () => step(1) }"
    }],
    staticClass: "px-6"
  }, _vm._l(_vm.slots, function (slot, i) {
    return _c('v-col', {
      key: slot.id,
      staticClass: "d-flex justify-center",
      staticStyle: {
        "z-index": "2"
      },
      attrs: {
        "cols": "4"
      }
    }, [_c('v-responsive', {
      staticClass: "overflow-visible",
      attrs: {
        "aspect-ratio": 5 / 7,
        "max-width": "220"
      }
    }, [_c('v-card', {
      staticClass: "absolute-fill",
      attrs: {
        "flat": "",
        "color": "transparent",
        "to": slot.to
      }
    }, [_c('v-card', {
      staticClass: "shelf-card front overflow-hidden",
      class: `anim-${i}`,
      style: {
        'animation-play-state': !_vm.isGroupLoaded ? 'paused' : 'running'
      },
      attrs: {
        "hover": "",
        "tile": ""
      }
    }, [slot.pages[0].mp4 ? _c('video', {
      attrs: {
        "playsinline": "",
        "autoplay": "",
        "muted": "",
        "loop": "",
        "src": slot.pages[0].mp4
      },
      domProps: {
        "muted": true
      },
      on: {
        "loadedmetadata": function ($event) {
          return _vm.loaded(i + '-0');
        }
      }
    }) : _c('img', {
      attrs: {
        "src": slot.pages[0].jpg
      },
      on: {
        "load": function ($event) {
          return _vm.loaded(i + '-0');
        }
      }
    })]), _c('v-card', {
      staticClass: "shelf-card back overflow-hidden",
      class: `anim-${i}`,
      staticStyle: {
        "transform": "rotateY(180deg)"
      },
      style: {
        'animation-play-state': !_vm.isGroupLoaded ? 'paused' : 'running'
      },
      attrs: {
        "hover": "",
        "tile": ""
      }
    }, [slot.pages[1].mp4 ? _c('video', {
      attrs: {
        "playsinline": "",
        "autoplay": "",
        "muted": "",
        "loop": "",
        "src": slot.pages[1].mp4
      },
      domProps: {
        "muted": true
      },
      on: {
        "loadedmetadata": function ($event) {
          return _vm.loaded(i + '-1');
        }
      }
    }) : _c('img', {
      attrs: {
        "src": slot.pages[1].jpg
      },
      on: {
        "load": function ($event) {
          return _vm.loaded(i + '-1');
        }
      }
    })])], 1)], 1)], 1);
  }), 1), _c('div', {
    staticClass: "shelf"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }